/**
 * Displays the main navigation links.
 */

import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { firebaseAuth } from '../provider/AuthProvider';

const Navlinks = ({
  closeMenu
}) => {
  const { user } = useContext(firebaseAuth);


  return (
    <ul>
      {user ? 
      <>
        <li>
          <NavLink to="/app" className="link" onClick={() => closeMenu()} activeClassName="active">
            Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink to="/appData" className="link" onClick={() => closeMenu()} activeClassName="active">
            Analyse
          </NavLink>
        </li>
        <li>
          <NavLink to="/mindmap" className="link" onClick={() => closeMenu()} activeClassName="active">
            Mindmap
          </NavLink>
        </li>
        <li>
          <NavLink to="/manage" className="link" onClick={() => closeMenu()} activeClassName="active">
            Beheer
          </NavLink>
        </li>
        <li>
          <NavLink to="/data" className="link" onClick={() => closeMenu()} activeClassName="active">
            Data
          </NavLink>
        </li>
        <li>
          <NavLink to="/my-account" className="link" onClick={() => closeMenu()} activeClassName="active">
            Mijn account
          </NavLink>
        </li>
        <li>
          <NavLink to="/log-out" className="link" onClick={() => closeMenu()} activeClassName="active">
            Log out
          </NavLink>
        </li>
      </>
      :
      <>
        <li>
          <NavLink to="/sign-up" className="link" onClick={() => closeMenu()} activeClassName="active">
            
          </NavLink>
          </li><li>
          <NavLink to="/log-in" className="link" onClick={() => closeMenu()} activeClassName="active">
            Log in
          </NavLink>
        </li>

      </>
      }
    </ul>
  )
}

export default Navlinks;